











































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import FormContent from "@/components/FormContent.vue";
import InputCommon from "@/components/lib/InputCommon.vue";
import ButtonCommon from "@/components/lib/ButtonCommon.vue";
import CheckboxCommon from "@/components/lib/CheckboxCommon.vue";
import ContactPicker from "@/components/contact/ContactPicker.vue";
import personalInfoFormMixin from "@/mixins/personalInfoFormMixin";
const IconCustom = () => import("@/components/lib/IconCustom.vue");
import {
  CONTACT_REQUEST_MESSAGE_MAX_LENGTH,
  ContactRequestPost,
  IContactRequestPostSimpleData,
  IContactRequestPostData,
  IContactRequest,
  ITravel,
} from "@/entities";
import { isEqual } from "lodash";

@Component({
  components: {
    FormContent,
    InputCommon,
    ButtonCommon,
    ContactPicker,
    CheckboxCommon,
    IconCustom,
  },
})
export default class ContactForm extends Mixins(personalInfoFormMixin) {
  @Prop() colorCondition!: boolean;
  @Prop() labelCondition!: boolean;
  @Prop() disableCancelButton!: boolean;

  private contactWays: number[] = [];

  get currentTravel(): ITravel {
    return this.$store.getters.getGroupTravel;
  }

  get CONTACT_REQUEST_MESSAGE_MAX_LENGTH(): number {
    return CONTACT_REQUEST_MESSAGE_MAX_LENGTH;
  }

  get iconCondition(): boolean {
    return isEqual(this.$route.path, "/travels") || this.$route.params.id
      ? true
      : false;
  }

  protected form: IContactRequestPostSimpleData = ContactForm.clearForm();

  protected get trimmedForm(): IContactRequestPostSimpleData {
    const handleMessage = this.form.message
      ? this.$route.params.id
        ? `${this.$route.params.id}____ ${this.form.message?.trim()}`
        : this.form.message?.trim()
      : "meesage from GROUP TRAVEl!!!";

    return {
      ...this.trimmedInfo,
      message: handleMessage,
    };
  }

  private static clearForm(): IContactRequestPostSimpleData {
    return {
      ...personalInfoFormMixin.clearForm(),
      message: "",
    };
  }

  get postForm(): IContactRequestPostData {
    return {
      ...this.trimmedForm,
      contact_ways: this.contactWays,
    };
  }

  protected submitOnSuccessAdditional(res?: any): void {
    this.form = ContactForm.clearForm();
  }
  protected submitOnSuccessAdditionalAsync(res?: any): void {
    (this.$refs["picker"] as any).reset();
  }

  protected actionPromise(): Promise<IContactRequest> {
    setTimeout(() => {
      this.$store.dispatch("setEmailModalCondition", false);
    }, 5000);

    let request = new ContactRequestPost(this.postForm);

    return this.$storage.actions.addContactRequest(request);
  }
}
